import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-cobalt/5 px-5 py-6 sm:py-8" data-id="element-177" data-mp="3fyhq1vsbkxc4">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-178" data-mp="2eshb609h71dz">
        <p className="text-[13px] font-medium text-ink sm:text-base" data-id="element-179" data-mp="29txotyqyznl3">
          <span className="text-cobalt" data-id="element-180" data-mp="29s34omnivzi2">Materiali interamente in italiano</span> · Pronti da stampare · Pensati per la scuola secondaria di secondo grado
        </p>
      </div>
    </section>;
}